import React, { Component } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Tooltip } from '@mui/material';

import { promiseReadFile } from '@paragon/client-tools';

import { uploadAnnotationsOrImage } from '../../actions/annotations';
import FileUploadButton from '../FileUploadButton';
import AddPhotoAlternateIcon from '../icons/AddPhotoAlternateIcon';

type Props = ReturnType<typeof mapDispatchToProps>;

class UploadObjectButton extends Component<Props> {
  onUploadAnnotation = async (files: FileList) => {
    const uploadedFile = await promiseReadFile(files[0]);

    await this.props.uploadAnnotationsOrImage(uploadedFile);
  };

  render() {
    return (
      <Tooltip disableInteractive disableFocusListener id="upload-object-tooltip" title="Upload Annotation/Image">
        <div className="uploadAnnotationImageDiv">
          <FileUploadButton
            withIcon
            accept=".png,.jpg,.json"
            aria-label="Upload Annotation"
            sx={{ borderRadius: 0 }}
            onFileSelected={this.onUploadAnnotation}
          >
            <AddPhotoAlternateIcon />
          </FileUploadButton>
        </div>
      </Tooltip>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators({ uploadAnnotationsOrImage }, dispatch);
}

export default connect(null, mapDispatchToProps)(UploadObjectButton);
